import { cn } from '@/utils/cn';
import { Spinner } from '@fleet/webshop-ui';
import type { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

export interface LoadableProps {
  loading: boolean;
  children: ReactNode;
  overlay?: boolean;
  persistent?: boolean;
  className?: { regular?: string; overlay?: string; persistent?: string };
}

export const Loadable: FC<LoadableProps> = ({
  loading,
  children,
  overlay,
  persistent,
  className,
}) => {
  if (overlay) {
    return (
      <>
        {loading &&
          createPortal(
            <>
              <div
                className={cn(
                  'pointer-events-auto fixed inset-0 z-[51] flex items-center justify-center text-primary',
                  className?.overlay
                )}
                data-testid="overlay-spinner-wrapper"
              >
                <Spinner size={64} />
              </div>
              <div className="pointer-events-auto fixed inset-0 z-[51] bg-gray-500 opacity-50" />
            </>,
            document.body
          )}
        {children}
      </>
    );
  }

  if (persistent) {
    return (
      <div
        className={cn('relative', className?.persistent)}
        data-testid="persistent-spinner-wrapper"
      >
        {children}
        {loading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-50 text-primary">
            <Spinner size={40} />
          </div>
        )}
      </div>
    );
  }

  return loading ? (
    <div
      className={cn(
        'flex items-center justify-center text-primary',
        className?.regular
      )}
    >
      <Spinner size={40} />
    </div>
  ) : (
    children
  );
};
